import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss/lib/injectSheet';
import { compose } from 'redux';
import cn from 'classnames';
import stylePlaceholders from '../../styles/placeholders';
import theme from '../../styles/theme';

const Loading = ({
  classes,
}) => (
  <div className={classes.placeholder}>
    <div className={classes.loading} />
    <div className={cn(classes.loading, classes.marginLeft)} />
    <div className={classes.loading} />
    <div className={cn(classes.loading, classes.marginLeft)} />
    <div className={classes.loading} />
    <div className={cn(classes.loading, classes.marginLeft)} />
  </div>
);

Loading.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default compose(
  injectSheet({
    loading: {
      fontFamily: theme.fonts.bold,
      letterSpacing: 0.3,
      fontSize: 16,
      marginBottom: 10,
      lineHeight: 1.5,
      minHeight: '2.7em',
      color: theme.colors.brandBlack,
      borderBottom: '1px solid #e4e4e4',
      height: 80,
    },
    marginLeft: {
      marginLeft: 80,
    },
    ...stylePlaceholders({
      loading: {
        dark: true, text: true, width: 300, height: 60,
      },
    }),
  }),
)(Loading);
